<template>
  <el-popover trigger="focus" placement="top" :disabled="!hasTips">
    <span style="display: block" v-for="(tip, tipIndex) in tips" v-html="tip" :key="tipIndex"></span>
    <el-input-number slot="reference" v-bind="props" :value="_value" :controls="false" @change="onInput"></el-input-number>
  </el-popover>
</template>

<script>
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props', 'value', 'emitUpdate'],
  computed: {
    key() {
      return this.props.name;
    },
    tips() {
      return this.props.tipRule || [];
    },
    hasTips() {
      return this.tips.length;
    },
    _value() {
      return this.emitUpdate ? this.value : this.alibabaForm[this.key];
    },
  },
  methods: {
    onInput(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateForm(newFormFields);
    },
    updateForm(valueObj) {
      if (this.emitUpdate) {
        this.$emit('change', valueObj);
      } else {
        this.updateAlibabaForm(valueObj);
      }
    },
  },
};
</script>

<style></style>